import { Callout } from '../../cdl/Callout/Callout';
import { Text } from '../../cdl/Text/Text';
import { GenericError } from '../../common/Error/GenericError';
import { translate } from '../../common/helpers/translate.helper';
import { useRole } from '../../common/hooks/useRole';
import { LoadingIndicator } from '../../common/LoadingIndicator/LoadingIndicator';
import { Box } from '../../common/ui/Box';
import { OfferModel } from '../model/OfferModel';

import { ActivityTimelineMessages } from './ActivityTimelineMessages';
import { getOfferChatAccessState } from './getOfferChatAccessState';
import { OfferActivityInput } from './OfferActivityInput';
import { OfferChatInfo } from './OfferChatInfo';
import { useMessages } from './useMessages';
import { useScrollToBottom } from './useScrollToBottom';

interface OfferActivityTimelineProps {
    offer: OfferModel;
}

export const OfferActivityTimeline = ({ offer }: OfferActivityTimelineProps) => {
    const role = useRole();
    const { messages, isPending, isError } = useMessages(offer);
    const messageBoxRef = useScrollToBottom({
        dependencies: messages,
    });
    const { showForwardedOfferInfoText, showInfoText, isMessagingAllowed } = getOfferChatAccessState(offer, role);

    if (isPending) {
        return (
            <Box display="flex" flexDirection="column" margin={24}>
                <LoadingIndicator />
            </Box>
        );
    }

    if (isError) {
        return (
            <Box display="flex" flexDirection="column" margin={24}>
                <GenericError variant="basic" />
            </Box>
        );
    }

    if (!messages.length) {
        return (
            <Box display="flex" flexDirection="column" backgroundColor="white">
                <Box display="flex" alignItems="center" justifyContent="center" padding={24}>
                    <Text variant="small" color="foreground.muted" style={{ textAlign: 'center' }}>
                        {translate('order.emptymessages')}
                    </Text>
                </Box>
                <OfferChatInfo showForwardedOfferInfoText={false} showInfoText={showInfoText} />
                {isMessagingAllowed ? (
                    <Box marginTop={24}>
                        <OfferActivityInput offerId={offer.id} />
                    </Box>
                ) : showForwardedOfferInfoText ? (
                    <Box marginTop={24}>
                        <Callout description={translate('order.forwardedOfferMessageInfo')} />
                    </Box>
                ) : null}
            </Box>
        );
    }

    return (
        <Box display="flex" flexDirection="column" backgroundColor="white" paddingBottom={80}>
            <ActivityTimelineMessages messages={messages} messageBoxRef={messageBoxRef} />
            <OfferChatInfo showForwardedOfferInfoText={false} showInfoText={showInfoText} />
            {isMessagingAllowed ? (
                <Box marginTop={24}>
                    <OfferActivityInput offerId={offer.id} />
                </Box>
            ) : showForwardedOfferInfoText ? (
                <Box marginTop={24}>
                    <Callout description={translate('order.forwardedOfferMessageInfo')} />
                </Box>
            ) : null}
        </Box>
    );
};
